export default __webpack_public_path__ + "static/media/33.f33146bc.jpg";